if (!customElements.get("product-card")) {
  class ProductCard extends HTMLElement {
    constructor() {
      super();
      // comment this in for js fetch of swatch product into current product card
      this.handleProductCardSwatchClick();
    }

    fetchProduct(event) {
      event.preventDefault();

      const variantId = event.currentTarget.dataset.variantId;
      const productUrl = event.currentTarget.dataset.productUrl;

      let fetchUrl = `${productUrl}`;
      if (variantId) {
        fetchUrl += `?variant=${variantId}`;
      }
      if (variantId) {
        fetchUrl += `&view=card-product--swatches`;
      } else {
        fetchUrl += `?view=card-product--swatches`;
      }

      fetch(fetchUrl)
        .then((response) => response.text())
        .then((text) => {
          const newHtml = new DOMParser().parseFromString(text, "text/html").querySelector("product-card");

          if (newHtml !== null) {
            this.replaceWith(newHtml);
          }

          const tpWidget = newHtml.querySelector(".trustpilot-widget");
          if (tpWidget) {
            if (window.Trustpilot && window.Trustpilot.loadFromElement) {
              Trustpilot.loadFromElement(tpWidget);
            }
          }
          
          setTimeout(() => {
            Samita?.ProductLabels?.init?.()
          }, 100)
        })
        .catch((e) => {
          console.error(e);
        });
    }

    handleProductCardSwatchClick() {
      const swatches = this.querySelectorAll(".product-card__swatches .product-card__swatch:not(.selected)");
      swatches.forEach((swatch) => {
        swatch.addEventListener("click", this.fetchProduct.bind(this));
      });
    }
  }

  customElements.define("product-card", ProductCard);
}
